import { render, staticRenderFns } from "./ErrorTemplate.vue?vue&type=template&id=71a4b5b2&"
import script from "./ErrorTemplate.vue?vue&type=script&lang=ts&"
export * from "./ErrorTemplate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports